import React, { useState } from 'react';
import { Box, Button } from '@mui/joy';

import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';

{/* PDF Viewer */ }
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import "react-pdf/dist/esm/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const MediaDisplay = ({ postMedia, handleDeleteMedia }) => {
    const [numPages, setNumPages] = useState();
    const [pageNumber, setPageNumber] = useState(1);
    const [showPreview, setShowPreview] = useState(null);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    return (
        <>
            {postMedia && (
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    maxWidth: '80vh',
                    overflowX: 'auto',
                    borderRadius: '5px',
                    border: '1px solid #E4E4E4',
                    backgroundColor: '#F5F5F5',
                }}>
                    {postMedia.photos.map((photo) => (
                        <div key={photo} style={{ position: 'relative' }}>
                            <Box
                                key={photo}
                                sx={{
                                    width: 100,
                                    height: 100,
                                    minWidth: 100,
                                    backgroundImage: `url(${process.env.NEXT_PUBLIC_AWS_URL}${photo})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    borderRadius: 'md',
                                    margin: 1,
                                    border: '1px solid #E4E4E4',
                                    borderRadius: '5px',
                                }}
                                onMouseEnter={() => setShowPreview(photo)}
                                onMouseLeave={() => setShowPreview(null)}
                                onClick={() => window.open(`${process.env.NEXT_PUBLIC_AWS_URL}${photo}`, '_blank')}
                            >

                                {showPreview === photo && (
                                    <div style={{
                                        position: 'relative',
                                        height: '100%',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                                        borderRadius: 'md',
                                        cursor: 'pointer',
                                    }}>
                                        <VisibilityIcon style={{ color: 'white' }} />
                                    </div>
                                )}
                            </Box>

                            <Box
                                sx={{
                                    position: 'relative',
                                    backgroundColor: 'white',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    padding: '10px 10px',
                                }}
                            >
                                <Button variant="solid" color="danger" sx={{ background: '#a51818 !important' }}
                                    onClick={() => handleDeleteMedia('photo', photo)}>
                                    <DeleteIcon />
                                </Button>
                            </Box>
                        </div>
                    ))}

                    {/* Display Video */}
                    {postMedia.video && (
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            maxWidth: '80vh',
                            overflowX: 'auto',
                            borderRadius: '5px',
                            border: '1px solid #E4E4E4',
                            backgroundColor: '#F5F5F5',
                        }}>
                            <div key={postMedia.video} style={{ position: 'relative' }}>
                                <Box sx={{
                                    width: 100,
                                    height: 100,
                                    minWidth: 100,
                                    margin: 1,
                                    border: '1px solid #E4E4E4',
                                    borderRadius: '5px',
                                    position: 'relative',
                                }}
                                    onMouseEnter={() => setShowPreview(postMedia.video)}
                                    onMouseLeave={() => setShowPreview(null)}
                                    onClick={() => window.open(`${process.env.NEXT_PUBLIC_AWS_URL}${postMedia.video}`, '_blank')}
                                >
                                    <video width="100" height="100" controls
                                        style={{
                                            borderRadius: '5px',
                                            position: 'relative',
                                            width: '100px',
                                            height: '100px',
                                        }}>
                                        <source src={`${process.env.NEXT_PUBLIC_AWS_URL}${postMedia.video}`} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>

                                    {showPreview === postMedia.video && (
                                        <div style={{
                                            position: 'absolute',
                                            width: '100px',
                                            height: '100px',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: 'rgba(0, 0, 0, 0.8)',
                                            borderRadius: '5px',
                                            cursor: 'pointer',
                                        }}>
                                            <VisibilityIcon style={{ color: 'white' }} />
                                        </div>
                                    )}
                                </Box>


                                <Box
                                    sx={{
                                        position: 'relative',
                                        backgroundColor: 'white',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                        padding: '10px 10px',
                                    }}
                                >
                                    <Button variant="solid" color="danger" sx={{ background: '#a51818 !important' }}
                                        onClick={() => handleDeleteMedia('video', postMedia.video)}>
                                        <DeleteIcon />
                                    </Button>
                                </Box>

                            </div>
                        </Box>
                    )}

                    {/* Display PDF */}


                    <style>
                        {`
                            .react-pdf__Page__canvas {
                                width: 100% !important;
                                height: 100% !important;
                            }
                        `}
                    </style>

                    {postMedia.pdf && (
                        <div key={postMedia.pdf} style={{ position: 'relative' }}>
                            <Box sx={{
                                width: 100,
                                height: 170,
                                minWidth: 100,
                                margin: 1,
                                border: '1px solid #E4E4E4',
                                borderRadius: '5px',
                            }}>

                                <div key={postMedia.pdf}
                                    onClick={() => window.open(`${process.env.NEXT_PUBLIC_AWS_URL}${postMedia.pdf}`, '_blank')}
                                    style={{
                                        position: 'relative',
                                        width: '100px',
                                        height: '100px',
                                        overflow: 'hidden',
                                        borderRadius: '5px',
                                        marginBottom: '5px',
                                    }}
                                    onMouseEnter={() => setShowPreview(postMedia.pdf)}
                                    onMouseLeave={() => setShowPreview(null)}
                                >
                                    <Document file={`${process.env.NEXT_PUBLIC_AWS_URL}${postMedia.pdf}`} onLoadSuccess={onDocumentLoadSuccess}>
                                        <Page pageNumber={pageNumber} />
                                    </Document>
                                    {showPreview === postMedia.pdf && (
                                        <div style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: 'rgba(0, 0, 0, 0.8)',
                                            borderRadius: '5px',
                                            cursor: 'pointer', // Change the cursor to indicate clickable
                                        }}
                                        >
                                            <VisibilityIcon style={{ color: 'white' }} />
                                        </div>
                                    )}
                                </div>

                                <Box
                                    sx={{
                                        position: 'relative',
                                        backgroundColor: 'white',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                        padding: '10px 10px',
                                    }}
                                >
                                    <Button variant="solid" color="danger" sx={{ background: '#a51818 !important' }}
                                        onClick={() => handleDeleteMedia('pdf', postMedia.pdf)}>
                                        <DeleteIcon />
                                    </Button>
                                </Box>
                            </Box>
                        </div>
                    )}



                </Box >
            )}
        </>
    );
}


export default MediaDisplay;
